import React from 'react';

import { getVideoEmbedUrl, isYouTubeId, parseVideoUrl } from '@helps/parseVideoUrl';

import styles from './style.module.scss';

const Video = ({ data = {} }) => {
    const { url = '', id = '' } = data || {};

    const parsed =
        parseVideoUrl(url) ||
        parseVideoUrl(id) ||
        (isYouTubeId(id) ? { type: 'youtube', id } : null);

    const embedUrl = getVideoEmbedUrl(parsed);

    if (!embedUrl) {
        return (
            <div className={styles.fallback}>
                Не удалось отобразить видео. Проверьте ссылку.
            </div>
        );
    }

    return (
        <div className={styles.video_container}>
            <iframe
                className={styles.video}
                src={embedUrl}
                title="Видео"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </div>
    );
};

export { Video };
